import { Component, OnInit, Input, ViewChild } from '@angular/core';

import { ConfirmationService, MenuItem } from 'primeng/api';
import { MessageService } from 'primeng/api';

// Export
import * as FileSaver from 'file-saver';
import { ExportService } from 'src/app/shared/services/export.service';

// Model
import { Table } from 'primeng/table';
import { ClientCrudService } from 'src/app/shared/services/client-crud.service';
import { Client } from 'src/app/shared/interfaces/client';

@Component({
  selector: 'app-client-list',
  templateUrl: './client-list.component.html',
  styleUrls: ['./client-list.component.scss']
})
export class ClientListComponent implements OnInit {

  clients: Client[];
  client: Client;
  selectedClients: Client[] = [];

  clientDialog: boolean = false;

  submitted: boolean = false;

  // column management
  cols: any[] = [];
  _selectedColumns: any[] = [];

  // export
  @ViewChild('dt', {static: true}) dt : any;
  exportColumns: any[] = [];

  // ui beadcrumb
  breadcrumbs: MenuItem[];
  homeBreadcrumb: MenuItem = {} as MenuItem;

  hideWhenNoPallet: boolean = false;
  noData: boolean = false;
  preLoader: boolean = true;

  separatorExp: string = "[,| ]";

  constructor(
    private clientService : ClientCrudService,
    private confirmationService: ConfirmationService,
    private messageService: MessageService,
    private exportService: ExportService
  ) { 
    // ui breadcrumbs
    this.breadcrumbs = [
      {label: 'Settings'},
      {label: 'Clients'}
    ];

    this.clients = [];
    this.client = { } as Client ;
  }

  ngOnInit(): void {

    this.isFilter = false;
    
    this.dataState();
    let s = this.clientService.getClientsList(); 
    s.snapshotChanges().subscribe(data => {
      this.clients = [];
      data.forEach(item => {
        let jsonItem : { '$key': string | null } = item.payload.toJSON() as { '$key': string | null } ; 
        if (jsonItem) {
          if (jsonItem) {
            jsonItem['$key'] = item.key;
          }
          let l : Client = jsonItem as Client;
          if (l.tags) {
            l.tags = Object.values(l.tags);
          }
          this.clients.push(jsonItem as Client);
        }
      })
    })

    // column management
    this.cols = [
      { field: 'companyName', header: 'Company Name' },
      { field: 'companyId', header: 'Company ABN/ACN' },
      { field: 'tags', header: 'Tags' },
      { field: 'isEnabled', header: 'Enabled' },
      { field: 'actions', header: 'Actions' } 
    ];


    this._selectedColumns = this.cols;
    this._selectedColumns = this._selectedColumns.filter( item => item.field !== 'description');
    this._selectedColumns = this._selectedColumns.filter( item => item.field !== 'isEnabled');

    // Exports
    //this.exportColumns = this.cols.map(col => ({title: col.header, dataKey: col.field}));
    this.exportColumns = this.cols.map(col => {
      if (col.field === 'position' || col.field === 'rank')  
        return {title: col.header, dataKey: 'position'};
      if (col.field !== 'actions')  
        return {title: col.header, dataKey: col.field};
      return {};
    } );
  }

  dataState() {     
    this.clientService.getClientsList().valueChanges().subscribe(data => {
      this.preLoader = false;
      if(data.length <= 0){
        this.hideWhenNoPallet = false;
        this.noData = true;
      } else {
        this.hideWhenNoPallet = true;
        this.noData = false;
      }
    })
  }

  includesCol(val: string) : boolean{
    let c = this._selectedColumns.find(c => c.field === val);
    return c;
  }

  // Column management
  @Input() get selectedColumns(): any[] {
    // console.log('selected columns', this._selectedColumns);
    return this._selectedColumns;
  }
  set selectedColumns(val: any[]) {
    //restore original order
    // console.log('before selected columns', this._selectedColumns);
    // console.log('before cols', this._selectedColumns);
    this._selectedColumns = this.cols.filter(col => val.includes(col));
    // console.log('after selected columns', this._selectedColumns);
  }

  // Export management
  exportPdf() {
    import("jspdf").then(jsPDF => {
        import("jspdf-autotable").then(x => {
            const doc = new jsPDF.default('l','pt');
            // @ts-ignore
            doc.autoTable(this.exportColumns, this.clients);
            doc.save('clients.pdf');
        })
    })
  }

  exportExcel() {
    import("xlsx").then(xlsx => {
        const worksheet = xlsx.utils.json_to_sheet(this.clients);
        const workbook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
        const excelBuffer: any = xlsx.write(workbook, { bookType: 'xlsx', type: 'array' });
        this.saveAsExcelFile(excelBuffer, "clients");
    });
  }

  exportDTCSV() {
    console.log('export csv');
    this.dt.exportCSV();
  }

  exportToCsv(): void {
    let exportCols : string[] = [];
    this.selectedColumns.forEach( sc => exportCols.push(sc.field));
    this.exportService.exportToCsv(this.selectedClients, 'clients', exportCols);
    //this.exportService.exportToCsv(this.clients, 'clients', ['companyId', 'companyName', '$key', 'actions']);
  }

  saveAsExcelFile(buffer: any, fileName: string): void {
    let EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    let EXCEL_EXTENSION = '.xlsx';
    const data: Blob = new Blob([buffer], {
        type: EXCEL_TYPE
    });
    FileSaver.saveAs(data, fileName + '_' + new Date().getTime() + EXCEL_EXTENSION);
  }

  // CRUD management
  openNew() {
    this.client = {} as Client;
    this.submitted = false;
    this.clientDialog = true;
  }

  deleteSelectedClients() {
    this.confirmationService.confirm({
        message: 'Are you sure you want to delete the selected clients?',
        header: 'Confirm',
        icon: 'pi pi-exclamation-triangle',
        accept: () => {
            this.clients = this.clients.filter(val => !this.selectedClients.includes(val));
            this.selectedClients = [];
            this.selectedClients.forEach( client => this.clientService.deleteClient(client.$key));
            this.messageService.add({severity:'success', summary: 'Successful', detail: 'Clients Deleted', life: 3000});
        }
    });
  }

  editClient(client: Client) {
    this.client = {...client};
    this.clientDialog = true;
  }

  deleteClient(client: Client) {
    this.confirmationService.confirm({
        message: 'Are you sure you want to delete ' + client.companyName + '?',
        header: 'Confirm',
        icon: 'pi pi-exclamation-triangle',
        accept: () => {
            this.clients = this.clients.filter(val => val.$key !== client.$key);
            this.client = {} as Client;
            this.clientService.deleteClient(client.$key);
            this.messageService.add({severity:'success', summary: 'Successful', detail: 'Client Deleted', life: 3000});
        }
    });
  }

  hideDialog() {
    this.clientDialog = false;
    this.submitted = false;
  }

  saveClient() {
    this.submitted = true;

    if ( this.client.companyName.trim() ) {
      if (this.client.$key) {
          this.clients[this.findIndexById(this.client.$key)] = this.client;                
          this.messageService.add({severity:'success', summary: 'Successful', detail: 'Client Updated', life: 3000});
          this.clientService.updateClient(this.client);
        } else {
          this.client.position = this.clients.length;
          this.clientService.addClient(this.client);
      }
      this.messageService.add({severity:'success', summary: 'Successful', detail: 'Client Created', life: 3000});
      this.clients = [...this.clients];
    }

    this.clientDialog = false;
    this.client = { } as Client;
  }

  findIndexById(id: string): number {
    let index = -1;
    for (let i = 0; i < this.clients.length; i++) {
        if (this.clients[i].$key === id) {
            index = i;
            break;
        }
    } 
    return index;
  }

  filter( dt : Table, event : {target: any} ) {
    dt.filterGlobal( (event.target as HTMLInputElement).value, 'contains')
  }

  completeClient(client : Client) {
    this.clientService.updateClient(client);
  }

  completePosition(client : Client) {
    if ( this.newPosition > -1 ) {
        client.position = this.newPosition;
        client = this.checkPositionLimits(client);
        this.reorderElements(client);
        //this.updateDB(spray);
        this.newPosition = -1;
        this.previousPosition = -1;
        return;
      }
  }


  @ViewChild('dt') tableElement: any; // already dt above
  isReordering : boolean = false;
  isAscReordering : boolean = false;
  isFilter : boolean = false;

  // Reorder
  reorder(event: any) {
    //console.log('Reorder event', event);
    // console.log('Before', this.sprays);
    // const myClonedArray = [];
    // this.sprays.forEach(val => myClonedArray.push(Object.assign({}, val)));
    // console.log('Before2', myClonedArray);
    if (event.dragIndex === event.dropIndex ) {
      return;
    }
    const startIndex = this.isAscReordering? event.dragIndex : this.clients.length - 1 - event.dragIndex;
    const endIndex   = this.isAscReordering? event.dropIndex : this.clients.length - 1 - event.dropIndex;
    const sprayToMove = this.clients[startIndex];
    
    if (startIndex < endIndex) {
      for(let index = startIndex; index < endIndex; index++) {
        this.clients[index] = this.clients[index+1];
        this.clients[index].position = index;
        this.clientService.updateClient(this.clients[index]);
      }     
    } else {
      for(let index = startIndex; index > endIndex; index--) {
        this.clients[index] = this.clients[index-1];
        this.clients[index].position = index;
        this.clientService.updateClient(this.clients[index]);
      }
    } 
    this.clients[endIndex] = sprayToMove;
    this.clients[endIndex].position = endIndex;
    this.clientService.updateClient(this.clients[endIndex]);
  }

  // onFieldEdit(spray: Spray, fieldName: string): void {
  //   //console.log(this.sprays);
  //   console.log("Edit Init Event Called");
  //   console.log('Field name :'+fieldName);
  //   console.log('Field value :' + spray[fieldName]);
  //   if (fieldName === 'position') {
  //     if ( this.newPosition ) {
  //       spray.position = this.newPosition;
  //       spray = this.checkPositionLimits(spray);
  //       this.reorderElements(spray);
  //       //this.updateDB(spray);
  //       this.newPosition = undefined;
  //       this.previousPosition = undefined;
  //       return;
  //     }
      
  //   } else {
  //     this.updateDB(spray);
  //   }
  // }


  ngAfterViewInit() {
    this.dt.onSort.subscribe((data: { field: string; order: number; }) => {
        if (data.field && data.field === "position") {
          this.isReordering = true;
          this.isAscReordering = (data.order == 1);
          // console.log("ASC", this.isAscReordering);
          // console.log("data.order", data.order);
        } else {
          this.isReordering = false;
        }
    });
    this.dt.onFilter.subscribe( (data: {
      filteredValue: {
        [x: string]: any; field: string; order: number; 
}; field: string; order: number; 
}) => {
      if (data && data.filteredValue) {
        this.isFilter = !(this.clients.length === data.filteredValue['length']);
      } else {
        this.isFilter = false;
      }
  });
  
}


  previousPosition : number = -1;
  newPosition : number = -1;

  modelChangeFn(event: number, spray: Client) {

    if (spray.position != null && spray.position > -1) {
      this.previousPosition = spray.position;
      this.newPosition = event;
    }
  
  }

  checkPositionLimits(spray: Client) {
    console.log('check ',spray.position + ' ' + this.clients.length);
    if (!spray.position) {
      console.log('check 1');
      return this.client;
    }
    if (spray.position < 0) {
      spray.position = 0;
      console.log('check 2');
      return spray;
    }
    if (spray.position > this.clients.length) {
      spray.position = this.clients.length - 1;
      console.log('check 3', spray.position);
      return spray;
    }
    console.log('check 4');
    return spray;
  }

  async reorderElements(spray: Client) {
    this.newPosition = this.newPosition  > this.clients.length ? this.clients.length - 1 : this.newPosition;
    this.newPosition = this.newPosition  < 0 ? 0 : this.newPosition;
    if (this.previousPosition === spray.position ) {
      return;
    }
    console.log('Previous position: '+ this.previousPosition);
    console.log('New position: '+ this.newPosition);
    const startIndex = this.previousPosition;
    const endIndex   = this.newPosition;
    const sprayToMove = this.clients[startIndex];
    console.log('Item to move: ', this.clients[startIndex]);
    if (startIndex < endIndex) {
      for(let index = startIndex; index < endIndex; index++) {

        console.log('LOC', this.clients);
        console.log('Item to +1: ', this.clients[index+1]);

        this.clients[index] = this.clients[index+1];
        this.clients[index].position = index;
        console.log('Move: ', this.clients[index+1]);
        console.log('Move pos: ', this.clients[index].position);
        //await this.updateDB(this.sprays[index]);
        this.clientService.updateClient(this.clients[index]);
        console.log('Update DB: ', this.clients[index]);
      }     
    } else {
      for(let index = startIndex; index > endIndex; index--) {
        this.clients[index] = this.clients[index-1];
        this.clients[index].position = index;
        this.clientService.updateClient(this.clients[index]);
      }
    } 
    this.clients[endIndex] = sprayToMove;
    this.clients[endIndex].position = endIndex;
    this.previousPosition = -1;
    this.newPosition = -1;
    this.clientService.updateClient(this.clients[endIndex]);
    
    // const myClonedArray = [];
    // this.sprays.forEach(val => myClonedArray.push(Object.assign({}, val)));
    // this.sprays = myClonedArray;
   // this.getAllRecords();
  }

}
